import { LandingPageState } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const defaultState: LandingPageState = {
    profiles: [],
    languages: [],
    currencies: [],
    countries: [],
    cities: [],
    states: [],
    account_creation_result: {success: false},
};

export const landingModule = {
    state: defaultState,
    mutations,
    actions,
    getters,
};
